import { css } from 'styled-components';
export const stretchButton = css `
  width: ${(props) => (props.$stretch ? `100%;` : `fit-content;`)};
`;
